import React from 'react'
import PropTypes from 'prop-types'
import Scrollspy from 'react-scrollspy'
import { Link } from 'react-scroll'

import Sticky from 'Pods/Shared/Sticky'

class HeaderNav extends React.Component {
  constructor() {
    super()

    this.state = {
      scrollOffset: -60,
    }
  }

  componentDidMount() {
    this.setState({ scrollOffset: -document.querySelector('.wayfinder').clientHeight })
  }

  render() {
    const additionalOffset = 52
    const {
      sections, isForUser, ctaButtons, localePathPrefix,
    } = this.props
    const hireFreelancersLabel = (ctaButtons && ctaButtons.hireFreelancers) || 'Hire 3D freelancers'
    const findJobsLabel = (ctaButtons && ctaButtons.findJobs) || 'Find 3D jobs'
    const offset = this.state.scrollOffset
    const normalizedLocalePrefix = localePathPrefix || ''
    const hireHref = `${normalizedLocalePrefix}/3d-modeling-jobs/hire-freelancers`.replace(/\/{2,}/g, '/')
    const findJobsHref = `${normalizedLocalePrefix}/3d-modeling-jobs/find-freelance-projects`.replace(/\/{2,}/g, '/')

    return (
      <Sticky
        className="enterprise-header-nav"
        position="top"
        stickyOffset={-offset}
        offset={-offset}
        selfAdjustingWidth
      >
        <div className="container-fixed">
          <div className="row">
            <div className="col-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
              <Scrollspy
                className="nav-tabs nav-tabs--small nav-tabs--navigation-menu nav-tabs--bigger-navigation-menu"
                items={sections.map(section => section.id)}
                currentClassName="is-active"
                offset={offset - additionalOffset}
              >
                {sections.map((section) => (
                  <li key={section.id}>
                    <Link
                      className="navigation-menu__link"
                      activeClass="is-active"
                      to={section.id}
                      offset={offset - additionalOffset}
                      duration={500}
                      spy
                      smooth
                    >{section.title}
                    </Link>
                  </li>
                ))}
                <span className="btn-tab-container">
                  <li className="btn-tab">
                    <a
                      href={hireHref}
                      className={`btn ${!isForUser ? 'btn-white' : 'btn-primary'}`}
                    >
                      {hireFreelancersLabel}
                    </a>
                    <a
                      href={findJobsHref}
                      className={`btn ${isForUser ? 'btn-white' : 'btn-primary'}`}
                    >
                      {findJobsLabel}
                    </a>
                  </li>
                </span>
              </Scrollspy>
            </div>
          </div>
        </div>
      </Sticky>
    )
  }
}

HeaderNav.propTypes = {
  sections: PropTypes.array.isRequired,
  isForUser: PropTypes.bool,
  ctaButtons: PropTypes.shape({
    hireFreelancers: PropTypes.string,
    findJobs: PropTypes.string,
  }),
  localePathPrefix: PropTypes.string,
}

HeaderNav.defaultProps = {
  isForUser: false,
  ctaButtons: null,
  localePathPrefix: '',
}

export default HeaderNav
